const lastAction = (state = null, action) => {
    return action;
};

export default lastAction;